import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Frown, Smile, TrendingDown, TrendingUp, Clock, Zap } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal relative" data-id="element-157">
      <div className="max-w-6xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-159">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-160">
            De no saber por dónde empezar… <br className="hidden sm:block" data-id="element-161" />
            <span className="text-gold italic font-normal" data-id="element-162">
              a vender en 30 días
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-[1fr_auto_1fr] gap-8 items-center" data-id="element-163">
          {/* Before Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-charcoal-dark border border-white/5 p-8 sm:p-10 rounded-3xl relative overflow-hidden" data-id="element-164">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-900/50 to-transparent" data-id="element-165" />
            <div className="flex items-center gap-4 mb-8" data-id="element-166">
              <div className="w-12 h-12 rounded-full bg-red-900/20 flex items-center justify-center" data-id="element-167">
                <Frown className="w-6 h-6 text-red-400/70" data-id="element-168" />
              </div>
              <h3 className="text-2xl font-serif text-cream-muted" data-id="element-169">Antes</h3>
            </div>

            <ul className="space-y-6" data-id="element-170">
              {[{
              icon: TrendingDown,
              text: 'Atrapado en la duda, sin ingresos extra'
            }, {
              icon: Clock,
              text: "Perdiendo tiempo buscando ideas 'perfectas'"
            }, {
              icon: Zap,
              text: 'Frustración por no saber cómo vender'
            }].map((item, i) => <li key={i} className="flex items-start gap-4 text-cream-muted/70" data-id="element-171">
                  <item.icon className="w-5 h-5 mt-0.5 flex-shrink-0 opacity-50" data-id="element-172" />
                  <span data-id="element-173">{item.text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Arrow */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="hidden md:flex w-16 h-16 rounded-full bg-warmBrown border border-gold/20 items-center justify-center z-10 shadow-[0_0_30px_rgba(212,168,83,0.15)]" data-id="element-174">
            <ArrowRight className="w-8 h-8 text-gold" data-id="element-175" />
          </motion.div>

          {/* After Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gradient-to-b from-warmBrown to-charcoal border border-gold/30 p-8 sm:p-10 rounded-3xl relative overflow-hidden shadow-[0_0_50px_rgba(212,168,83,0.1)]" data-id="element-176">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold to-gold-dark" data-id="element-177" />
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-gold/20 blur-[60px] rounded-full pointer-events-none" data-id="element-178" />

            <div className="flex items-center gap-4 mb-8 relative z-10" data-id="element-179">
              <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center border border-gold/30" data-id="element-180">
                <Smile className="w-6 h-6 text-gold" data-id="element-181" />
              </div>
              <h3 className="text-2xl font-serif text-gold" data-id="element-182">Después</h3>
            </div>

            <ul className="space-y-6 relative z-10" data-id="element-183">
              {[{
              icon: TrendingUp,
              text: 'Vendiendo focaccias y recibiendo dinero real'
            }, {
              icon: Clock,
              text: 'Sistema simple que funciona en tu tiempo libre'
            }, {
              icon: Zap,
              text: 'Confianza total con un paso a paso claro'
            }].map((item, i) => <li key={i} className="flex items-start gap-4 text-cream" data-id="element-184">
                  <item.icon className="w-5 h-5 mt-0.5 flex-shrink-0 text-gold" data-id="element-185" />
                  <span className="font-medium" data-id="element-186">{item.text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}